import { Box, Button, TextField, Typography } from '@mui/material'
import { useContext, useState } from 'react'

import { Modal } from '../../../components/Modal/Modal'
import {
  ResourcesContext,
  ResourcesContextInterface,
} from '../../../providers/Resources/Resources.provider'
import { ResourceFolder, ResourceItem } from './Resources.view'

interface CreateResourceFolderModalInterface {
  currentFolder: ResourceFolder | null
  currentFolderContent: ResourceItem[] | null
  createFolderModalOpen: boolean
  setCreateFolderModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  fetchFolderContent: (folderId: number) => Promise<void>
}

export const CreateResourceFolderModal = ({
  currentFolder,
  createFolderModalOpen,
  setCreateFolderModalOpen,
  setLoading,
  fetchFolderContent,
}: CreateResourceFolderModalInterface) => {
  const { getRootResourceFolders, createResourceFolder } = useContext(
    ResourcesContext
  ) as ResourcesContextInterface

  const [newFolderName, setNewFolderName] = useState<string>('')

  return (
    <Modal
      title={currentFolder ? 'Create New Subfolder' : 'Create Root Folder'}
      open={createFolderModalOpen}
      setOpen={setCreateFolderModalOpen}
      ModalContent={
        <Box sx={{ p: 2 }}>
          <Typography style={{ marginBottom: '15px' }}>
            Create new {currentFolder ? 'subfolder' : 'root folder'}:
          </Typography>
          <TextField
            fullWidth
            label='Enter Folder Name'
            variant='outlined'
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
          <Box
            sx={{
              mt: 3,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={() => setCreateFolderModalOpen(false)}
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={async () => {
                setLoading(true)
                // Close modal and refresh folder content after creation
                setCreateFolderModalOpen(false)
                setNewFolderName('')

                currentFolder
                  ? await createResourceFolder(newFolderName, currentFolder.id)
                  : await createResourceFolder(newFolderName)

                if (currentFolder && currentFolder.id) {
                  fetchFolderContent(currentFolder.id)
                } else {
                  await getRootResourceFolders()
                  setLoading(false)
                }
              }}
              disabled={!newFolderName.trim()}
            >
              Create Folder
            </Button>
          </Box>
        </Box>
      }
    />
  )
}
